import { render, staticRenderFns } from "./query-result.vue?vue&type=template&id=2d66ce54&scoped=true"
import script from "./query-result.vue?vue&type=script&lang=js"
export * from "./query-result.vue?vue&type=script&lang=js"
import style0 from "./query-result.vue?vue&type=style&index=0&id=2d66ce54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d66ce54",
  null
  
)

export default component.exports